module.exports = __webpack_public_path__ + "img/Z61_04.73460024.jpg";